export default __webpack_public_path__ + "static/media/kitchen5-beforeE-2048w.59d2aca4.avif";